export class FileHelper {
  static Base64ToFile(fileName: string, base64String: string, labelFormat: string) {
    const blob = this.Base64toBlob(base64String, "application/" + labelFormat);
    const blobUrl = window.URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");

    downloadLink.href = blobUrl;
    downloadLink.download = fileName;

    // Append to the document body
    document.body.appendChild(downloadLink);

    // Trigger the click event
    downloadLink.click();

    // Remove the link from the document body
    document.body.removeChild(downloadLink);

    // Clean up the Blob URL
    window.URL.revokeObjectURL(blobUrl);
  }

  static Base64toBlob(b64Data: string, contentType: string, sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}
